import { render, staticRenderFns } from "./e-serp-snippet-simulator.vue?vue&type=template&id=5a2d2d70&scoped=true"
import script from "./e-serp-snippet-simulator.vue?vue&type=script&lang=js"
export * from "./e-serp-snippet-simulator.vue?vue&type=script&lang=js"
import style0 from "./e-serp-snippet-simulator.vue?vue&type=style&index=0&id=5a2d2d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d2d70",
  null
  
)

export default component.exports